<app-toasts-v2></app-toasts-v2>
<app-notification-drawer></app-notification-drawer>
<div class="flex h-screen bg-surface-light-0">
  @if(shouldShowSidebar() && !closeSideBar) {
    <div class="w-[240px] shrink-0 max-md:absolute max-md:z-[60] transition-all duration-500 overflow-hidden" [ngClass]="{'max-md:w-0': !mobileSidebarToggle}">
      <side-bar (closeMobileSidebar)="mobileSidebarToggle = false"/>
    </div>
    @if (mobileSidebarToggle) {
      <div class="h-full w-full backdrop-blur-md bg-black/20 absolute z-50 transition-all duration-500 md:hidden" (click)="mobileSidebarToggle = false"></div>
    }
  }
  <div class="flex-1 overflow-y-auto">
    @if(shouldShowSidebar() && !closeSideBar) {
      <div class="px-8 md:hidden pt-6">
        <p-button (click)="mobileSidebarToggle = true" icon="pi pi-bars" severity="secondary" outlined/>
      </div>
    }
    <router-outlet/>
  </div>
</div>

<app-ai-assistant />
